import type { Panel } from "."
import type { Point2d, Scale2d } from "../2d"
import { rotatePoint } from "../2d"
export type PlacePotentialPanels = (options: {
  originalPanel: Panel
  creatingPanel: Panel
  isAligned: boolean
  isLandscape: boolean
}) => Point2d[]

export const placePotentialPanels: PlacePotentialPanels = ({
  originalPanel,
  creatingPanel,
  isAligned,
  isLandscape,
}) => {
  const { x, y } = originalPanel
  const origin = { x, y }
  const rotateAboutOrigin = (p: Point2d) =>
    rotatePoint(origin, p, originalPanel.r)

  if (isAligned) {
    const { w, h } = originalPanel
    const lf = { x: x - w, y }
    const rt = { x: x + w, y }
    const up = { x, y: y - h }
    const dn = { x, y: y + h }

    return [up, rt, dn, lf].map(rotateAboutOrigin)
  }
  const { w: w0, h: h0 } = originalPanel
  const { w: w1, h: h1 } = creatingPanel
  const pointPairs = isLandscape
    ? {
        up: {
          left: { x: x + w0, y: y - w1 },
          right: { x: x + h1, y: y - w1 },
        },
        down: {
          left: { x: x + w0, y: y + h0 },
          right: { x: x + h1, y: y + h0 },
        },
        left: {
          up: { x, y },
          down: { x, y: y + h0 - w1 },
        },
        right: {
          up: { x: x + w0 + h1, y },
          down: { x: x + w0 + h1, y: y + h0 - w1 },
        },
      }
    : {
        up: {
          left: { x: x - h1 + w0, y },
          right: { x, y },
        },
        down: {
          left: { x: x - h1 + w0, y: y + h0 + w1 },
          right: { x: x, y: y + h0 + w1 },
        },
        left: {
          up: { x: x - h1, y: y + w1 },
          down: { x: x - h1, y: y + h0 },
        },
        right: {
          up: { x: x + w0, y: y + w1 },
          down: { x: x + w0, y: y + h0 },
        },
      }
  const { up, down, left, right } = pointPairs

  return [
    up.left,
    up.right,
    down.left,
    down.right,
    left.up,
    left.down,
    right.up,
    right.down,
  ].map(rotateAboutOrigin)
}
